// @flow
import React from "react";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /* searchDisputeAsnRtv*/
  function* searchDisputeAsnRtv(action) {
    try {
      const response = yield call(
        api.disputes.searchDisputeAsnRtv,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.searchDisputeAsnRtvSuccess(response.data));
      } else {
        yield put(
          Actions.searchDisputeAsnRtvFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.searchDisputeAsnRtvFailure(error));
    }
  }
  function* watchSearchDisputeAsnRtv(): Generator<void, void, void> {
    yield takeLatest(Types.SEARCH_DISPUTE_ASN_RTV, searchDisputeAsnRtv);
  }
  /* listDisputeReasons*/
  function* listDisputeReasons(action) {
    try {
      const response = yield call(
        api.disputes.listDisputeReasons,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.listDisputeReasonsSuccess(response.data));
      } else {
        yield put(
          Actions.listDisputeReasonsFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.listDisputeReasonsFailure(error));
    }
  }
  function* watchListDisputeReasons(): Generator<void, void, void> {
    yield takeLatest(Types.LIST_DISPUTE_REASONS, listDisputeReasons);
  }
  /* listDisputes*/
  function* listDisputes(action) {
    try {
      const response = yield call(api.disputes.listDisputes, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.listDisputesSuccess(response.data));
      } else {
        yield put(Actions.listDisputesFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.listDisputesFailure(error));
    }
  }
  function* watchListDisputes(): Generator<void, void, void> {
    yield takeLatest(Types.LIST_DISPUTES, listDisputes);
  }

  /* createDispute*/
  function* createDispute(action) {
    try {
      const response = yield call(api.disputes.createDispute, action.payload);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.createDisputeSuccess(response.data));
      } else {
        yield put(Actions.createDisputeFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.createDispute(error));
    }
  }
  function* watchCreateDispute(): Generator<void, void, void> {
    yield takeLatest(Types.CREATE_DISPUTE, createDispute);
  }

  return {
    watchSearchDisputeAsnRtv,
    watchCreateDispute,
    watchListDisputes,
    watchListDisputeReasons
  };
};



// WEBPACK FOOTER //
// ./src/sagas/DisputesSaga.js